function getCartTotal() {
  var cartTotalEl = document.querySelector('[data-cart-subtotal]');
  if (!cartTotalEl) return 0;
  var rawAttr = cartTotalEl.getAttribute('value');
  if (rawAttr) return parseInt(rawAttr.replace(/[^0-9]/g, ''), 10);
  var rawText = cartTotalEl.textContent || cartTotalEl.innerText || '';
  return parseInt(rawText.replace(/[^0-9]/g, ''), 10);
}

function updateShippingEstimate() {
  var select = document.getElementById('shipping-country-select');
  var result = document.getElementById('shipping-estimate-result');
  var totalEstimated = document.getElementById('shipping-total-estimated');
  if (!select || !result) return;

  var cartTotal = getCartTotal();
  var country = select.value;
  var thresholdIT = 6500;
  var thresholdEU = 7500;
  var shippingCost = 0;

  if (country === 'IT') {
    if (cartTotal >= thresholdIT) {
      result.innerHTML = '<p style="color: green; font-weight: 600;">🎉 Spedizione gratuita!</p>';
      shippingCost = 0;
    } else {
      var rem = ((thresholdIT - cartTotal) / 100).toFixed(2).replace('.', ',');
      result.innerHTML = '<p>Spedizione: <strong>€5,90</strong></p><p style="color:#666; font-size:0.9em;">Aggiungi <strong>€' + rem + '</strong> per la spedizione gratuita.</p>';
      shippingCost = 590;
    }
  } else {
    if (cartTotal >= thresholdEU) {
      result.innerHTML = '<p style="color: green; font-weight: 600;">🎉 Spedizione gratuita!</p>';
      shippingCost = 0;
    } else {
      var rem = ((thresholdEU - cartTotal) / 100).toFixed(2).replace('.', ',');
      result.innerHTML = '<p>Spedizione: <strong>€10,00</strong></p><p style="color:#666; font-size:0.9em;">Aggiungi <strong>€' + rem + '</strong> per la spedizione gratuita.</p>';
      shippingCost = 1000;
    }
  }

  if (totalEstimated) {
    var grandTotal = ((cartTotal + shippingCost) / 100).toFixed(2).replace('.', ',');
    totalEstimated.innerHTML = 'Totale stimato (spedizione inclusa): <strong>€' + grandTotal + '</strong>';
  }
}

// Cambio select paese
document.addEventListener('change', function(e) {
  if (e.target && e.target.id === 'shipping-country-select') {
    updateShippingEstimate();
  }
});

// Aggiornamento quantità/prodotti
document.addEventListener('cart:update', function() {

  setTimeout(updateShippingEstimate, 500);
});

// Apertura drawer via evento nativo dialog
document.addEventListener('dialog:open', function(e) {
  if (e.target && e.target.tagName === 'CART-DRAWER-COMPONENT') {
    setTimeout(updateShippingEstimate, 400);
  }
});

// Fallback: osserva solo l'attributo "open" sul dialog dentro cart-drawer
var drawerWatchTimer = setInterval(function() {
  var drawerEl = document.querySelector('cart-drawer-component dialog');
  if (drawerEl) {
    clearInterval(drawerWatchTimer);
    var wasOpen = false;
    var drawerObserver = new MutationObserver(function() {
      var isOpen = drawerEl.hasAttribute('open');
      if (isOpen && !wasOpen) {
        wasOpen = true;
        setTimeout(updateShippingEstimate, 400);
      } else if (!isOpen) {
        wasOpen = false;
      }
    });
    drawerObserver.observe(drawerEl, { attributes: true, attributeFilter: ['open'] });
  }
}, 500);
